import { defineMessages } from 'react-intl';

export const zoneMessages = defineMessages({
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    zone: {
        id: 'zone',
        defaultMessage: 'Zone',
    },
    editZone: {
        id: 'edit-zone',
        defaultMessage: 'Edit zone',
    },
    addZone: {
        id: 'add-zone',
        defaultMessage: 'Add zone',
    },
    addZoneSubtitle: {
        id: 'add-zone-subtitle',
        defaultMessage: 'Add new zone',
    },
    editZoneSubtitle: {
        id: 'edit-zone-subtitle',
        defaultMessage: 'Edit zone {entry}',
    },
    deleteZoneSubtitle: {
        id: 'delete-zone-subtitle',
        defaultMessage: 'Permanently delete zone {entry}',
    },
    confirmDeleteZone: {
        id: 'confirm-delete-zone',
        defaultMessage: 'Are you sure you want to delete zone {entry}? This action cannot be undone.',
    },
    createZoneSuccessDescription: {
        id: 'create-zone-success-description',
        defaultMessage: 'Zone {entry} has been successfully created.',
    },
    updateZoneSuccessDescription: {
        id: 'update-zone-success-description',
        defaultMessage: 'Zone {entry} has been successfully updated.',
    },
    deleteZoneSuccessDescription: {
        id: 'delete-zone-success-description',
        defaultMessage: 'Zone {entry} has been successfully deleted.',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    site: {
        id: 'site',
        defaultMessage: 'Site',
    },
    parentZone: {
        id: 'parent-zone',
        defaultMessage: 'Parent zone',
    },
    totalSpaces: {
        id: 'total-spaces',
        defaultMessage: 'Total spaces',
    },
    spacesCount: {
        id: 'spaces-count',
        defaultMessage: 'Spaces count',
    },
    overflowSpaces: {
        id: 'overflow-spaces',
        defaultMessage: 'Overflow spaces',
    },
    limitAccessCapacity: {
        id: 'limit-access-capacity',
        defaultMessage: 'Limit access per capacity',
    },
    limitUserAccess: {
        id: 'limit-user-access',
        defaultMessage: 'Limit user access',
    },
    createZoneSuccess: {
        id: 'create-zone-success',
        defaultMessage: 'Zone created',
    },
    updateZoneSuccess: {
        id: 'update-zone-success',
        defaultMessage: 'Zone updated',
    },
    deleteZoneSuccess: {
        id: 'delete-zone-success',
        defaultMessage: 'Zone deleted',
    },
    regular: {
        id: 'regular',
        defaultMessage: 'Regular',
    },
    vip: {
        id: 'vip',
        defaultMessage: 'VIP',
    },
    disabled: {
        id: 'disabled',
        defaultMessage: 'Disabled',
    },
    ev: {
        id: 'ev',
        defaultMessage: 'EV',
    },
    motorcycle: {
        id: 'motorcycle',
        defaultMessage: 'Motorcycle',
    },
    buffer: {
        id: 'buffer',
        defaultMessage: 'Buffer',
    },
    organisation: {
        id: 'organisation',
        defaultMessage: 'Organisation',
    },
    userAccess: {
        id: 'user-access',
        defaultMessage: 'Allowed users',
    },
    allowUnknownIdentifier: {
        id: 'allow-unknown-main-identifier',
        defaultMessage: 'Allow unknown main identifier',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    addVisitorLimit: {
        id: 'add-visitor-limit',
        defaultMessage: 'Add visitor limit',
    },
    categories: {
        id: 'categories',
        defaultMessage: 'Categories',
    },
    client: {
        id: 'client',
        defaultMessage: 'Client',
    },
    resident: {
        id: 'resident',
        defaultMessage: 'Resident',
    },
    staff: {
        id: 'staff',
        defaultMessage: 'Staff',
    },
    service: {
        id: 'service',
        defaultMessage: 'Service',
    },
    reservation: {
        id: 'reservation',
        defaultMessage: 'Reservation',
    },
    visitorSpacesLimit: {
        id: 'visitor-spaces-limit',
        defaultMessage: 'Visitor spaces limit',
    },
    capacityLimits: {
        id: 'capacity-limits',
        defaultMessage: 'Capacity limits',
    },
    count: {
        id: 'count',
        defaultMessage: 'Count',
    },
    info: {
        id: 'information',
        defaultMessage: 'Information',
    },
    backToAllZones: {
        id: 'back-to-all-zones',
        defaultMessage: 'Back to all zones',
    },
    visitorCategories: {
        id: 'visitor-categories',
        defaultMessage: 'Visitor categories',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
});